export default "__VITE_ASSET__b5755e52__"